import {
  Stack,
  Typography,
  DialogContentText,
  DialogTitle,
  Divider,
  TextField,
  Box,
} from "@material-ui/core";
import { DialogAnimate } from "../../../../components/animate";
import Scrollbar from "../../../../components/Scrollbar";
// ----------------------------------------------------------------------
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import apiUser from "../../../../api/user";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack5";
import ColorTagMultiPicker from "../../../../components/ColorTagMultiPicker";
import ColorSinglePicker from "../../../../components/ColorSinglePicker";
import ColorSinglePickerToUpdate from "../../../../components/ColorSinglePickerToUpdate";
import { Button } from "@mui/material";
import ColorTagSinglePicker from "../../../../components/ColorTagSinglePicker";
import e from "cors";

const COLOR_OPTIONS_MORE = [
  "#00AB55", // theme.palette.primary.main,
  "#1890FF", // theme.palette.info.main,
  "#94D82D", // theme.palette.success.main,
  "#FFC107", // theme.palette.warning.main,
  "#FF4842", // theme.palette.error.main
  "#04297A", // theme.palette.info.darker
  "#7A0C2E", // theme.palette.error.darker
];
export default function DialogSettingTags({
  isOpenSettingTags,
  setIsOpenSettingTags,
  setIsRefreshContact,
  setLoadingFieldContact
}) {
  const [colorOptions, setColorOptions] = useState([]);
  //   const [selectedColors, setSelectedColors] = useState([]);
  const [updateTag, setUpdateTag] = useState(false);
  const [errorAddTag, setErrorAddTag] = useState(false);
  const [messageErrorAddTag, setMessageErrorAddTag] = useState("");
  const [errorUpdateTag, setErrorUpdateTag] = useState(false);
  const [messageErrorUpdateTag, setMessageErrorUpdateTag] = useState("");
  const [idTagSelectedUpdate, setIdTagSelectedUpdate] = useState("");
  const [colorSelectedUpdate, setColorSelectedUpdate] = useState("");
  const [titleSelectedUpdate, setTitleSelectedUpdate] = useState("");
  const [colorToInsert, setColorToInsert] = useState("");
  const [titleToInsert, setTitleToInsert] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  // const COLOR_OPTIONS = [
  //   { id: 1, color: "#FF4842", tag: "VIP" },
  //   { id: 2, color: "#3BEF37", tag: "Mới" },
  //   { id: 3, color: "#1890FF", tag: "Quan Tâm" },
  //   { id: 4, color: "#FFC107", tag: "Thường" },
  //   { id: 5, color: "#04297A", tag: "Đã Chốt" },
  // ];

  const findTags = async () => {
    try {
      const res = await apiUser.find_tags();
      if (res.status === 200) {
        let resDataTags = res?.data?.data;
        setColorOptions(resDataTags);
      } else {
        // setColorOptions(COLOR_OPTIONS);
        enqueueSnackbar(
          // "Không tìm thấy danh sách tags, đang dùng mẫu mặc định !",
          "Không tìm thấy danh sách nhãn, vui lòng thêm nhãn !",
          { variant: "error" }
        );
        setColorOptions([]);
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar(
        "Không tìm thấy danh sách nhãn, vui lòng thêm nhãn !",
        { variant: "error" }
      );
      setColorOptions([]);
      // setColorOptions(COLOR_OPTIONS);
    }
    // setColorOptions(res?.data);
  };
  useEffect(() => {
    findTags();
  }, []);

  const handleChooseTag = (e) => {
    const tag = JSON.parse(e.target.value);
    // setSelectedColors(tag);
    setIdTagSelectedUpdate(tag.id);
    setColorSelectedUpdate(tag.color);
    setTitleSelectedUpdate(tag.tag);
    setUpdateTag(true);
  };

  const handleAddTag = async () => {
    if (titleToInsert === "" || colorToInsert === "") {
      setErrorAddTag(true);
      setMessageErrorAddTag("Bạn chưa chọn màu hoặc nhập tên nhãn !!!");
      return;
    }
    if (titleToInsert.length > 20) {
      setErrorAddTag(true);
      setMessageErrorAddTag("Tên nhãn không quá 20 ký tự !!!");
      return;
    }
    try {
      const insertTag = await apiUser.insert_tags({
        tag: titleToInsert,
        color: colorToInsert,
      });
      if (insertTag.status === 200) {
        setUpdateTag(false);
        findTags();
        enqueueSnackbar("Thêm nhãn thành công !", { variant: "success" });
        setColorToInsert("");
        setTitleToInsert("");
      } else {
        enqueueSnackbar("Thêm nhãn thất bại, vui lòng thử lại !", {
          variant: "error",
        });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Thêm nhãn thất bại, vui lòng thử lại !", {
        variant: "error",
      });
    }
    setErrorAddTag(false);
    setMessageErrorAddTag("");
    setUpdateTag(false);
  };

  const handleUpdateTag = async () => {
    if (titleSelectedUpdate === "" || colorSelectedUpdate === "") {
      setErrorUpdateTag(true);
      setMessageErrorUpdateTag("Bạn chưa chọn màu hoặc nhập tên nhãn !!!");
      return;
    }
    if (titleSelectedUpdate.length > 20) {
      setErrorUpdateTag(true);
      setMessageErrorUpdateTag("Tên nhãn không quá 20 ký tự !!!");
      return;
    }
    try {
      const updateTag = await apiUser.edit_tags({
        id: idTagSelectedUpdate,
        tag: titleSelectedUpdate,
        color: colorSelectedUpdate,
      });
      if (updateTag.status === 200) {
        setUpdateTag(false);
        findTags();
        enqueueSnackbar("Cập nhật nhãn thành công !", { variant: "success" });
        setColorSelectedUpdate("");
        setTitleSelectedUpdate("");
      } else {
        enqueueSnackbar("Cập nhật nhãn thất bại, vui lòng thử lại !", {
          variant: "error",
        });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Cập nhật nhãn thất bại, vui lòng thử lại !", {
        variant: "error",
      });
    }
    setErrorUpdateTag(false);
    setMessageErrorUpdateTag("");
    setUpdateTag(false);
  };
  const handleDeleteTag = async () => {
    try {
      const deleteTag = await apiUser.delete_tags({
        id: idTagSelectedUpdate,
      });
      if (deleteTag.status === 200) {
        setUpdateTag(false);
        findTags();
        enqueueSnackbar("Xóa nhãn thành công !", { variant: "success" });
      } else {
        enqueueSnackbar("Xóa nhãn thất bại, vui lòng thử lại !", {
          variant: "error",
        });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Xóa nhãn thất bại, vui lòng thử lại !", {
        variant: "error",
      });
    }
  };
  return (
    <DialogAnimate
      sx={{ maxHeight: 900 }}
      open={isOpenSettingTags}
      onClose={() => {
        setIsOpenSettingTags(false);
        setIsRefreshContact(true);
        setLoadingFieldContact(true);
      }}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle>
        <Stack direction="row" justifyContent="flex-start" spacing={2}>
          <CollectionsBookmarkIcon
            style={{ fontSize: "36px", marginTop: "10px", color: "#2978d5" }}
          />
          <Typography variant="h4" style={{ marginTop: "10px" }}>
            Thêm/Sửa nhãn
          </Typography>
        </Stack>
      </DialogTitle>
      <Divider></Divider>
      <DialogContentText>
        <Scrollbar>
          <Stack direction="column" spacing={1} sx={{ p: 2 }}>
            <Stack direction={"row"} spacing={1}>
              <Typography variant="body2" sx={{ fontSize: "16px" }}>
                <strong>Thêm nhãn:</strong>
              </Typography>
            </Stack>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 3, sm: 2 }}
            >
              <ColorSinglePicker
                onChange={(e) => setColorToInsert(e.target.value)}
                colors={COLOR_OPTIONS_MORE}
              />
              <TextField
                onChange={(e) => setTitleToInsert(e.target.value)}
                error={errorAddTag}
                helperText={messageErrorAddTag}
                variant="standard"
                label="Tên Nhãn"
                value={titleToInsert}
              />
              <Button
                onClick={(e) => handleAddTag(e)}
                color="secondary"
                variant="contained"
                sx={{ ml: 1, height: "46px" }}
              >
                Thêm nhãn
              </Button>
            </Stack>
            {colorOptions.length > 0 ? (
              <>
                <Stack direction={"row"} sx={{ mt: 6 }} spacing={1}>
                  <Typography variant="body2" sx={{ fontSize: "16px" }}>
                    <strong>Sửa nhãn:</strong>
                  </Typography>
                </Stack>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={{ xs: 3, sm: 2 }}
                >
                  <ColorTagSinglePicker
                    onChange={(e) => handleChooseTag(e)}
                    colors={colorOptions}
                  />
                </Stack>

                {updateTag && (
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={{ xs: 3, sm: 2 }}
                  >
                    <ColorSinglePickerToUpdate
                      colors={COLOR_OPTIONS_MORE}
                      valueDefault={colorSelectedUpdate}
                      onChange={(e) => setColorSelectedUpdate(e)}
                    />
                    <TextField
                      error={errorUpdateTag}
                      helperText={messageErrorUpdateTag}
                      value={titleSelectedUpdate}
                      onChange={(e) => setTitleSelectedUpdate(e.target.value)}
                      variant="standard"
                      label="Tên Nhãn"
                    />
                    <Button
                      onClick={(e) => handleUpdateTag(e)}
                      color="secondary"
                      variant="contained"
                      sx={{ ml: 1, height: "46px" }}
                    >
                      Cập nhật
                    </Button>
                    <Button
                      onClick={(e) => handleDeleteTag(e)}
                      color="error"
                      variant="contained"
                      sx={{ ml: 1, height: "46px" }}
                    >
                      Xóa nhãn
                    </Button>
                  </Stack>
                )}
              </>
            ) : null}
          </Stack>
        </Scrollbar>
      </DialogContentText>
    </DialogAnimate>
  );
}
